/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import useMediaQuery from '../../hooks/useMediaQuery';
import publicPath from '../../utils/publicPath';
import AccredationLevel from '../AccredationLevel';
import DisplayInformation from '../DisplayInformation';
import Text from '../Text';
import useStyles from '../VenueDetails/styles';
import useStylesClub from './styles';

export const aboutClubRef = React.createRef();

const ClubDetails = ({
  footballtypes,
  accreditation,
  facilities,
  county,
  title,
}) => {
  const styles = useStyles();
  const stylesClub = useStylesClub();

  const hasMoreInfo =
    county || (accreditation && accreditation.isAccreditation);
  const { values: footballTypesValues } = footballtypes;
  const { values: facilitiesVals } = facilities;
  const facilitiesValues = [facilitiesVals[2], ...facilitiesVals.slice(0, 2)];
  const filteredFootballTypesValues = footballTypesValues.filter(
    value => value.title !== 'Teams gender groups'
  );
  const MQtoHideQuickLinks = useMediaQuery('screen and (max-width: 600px)');

  return (
    <Fragment>
      <div css={stylesClub.middlePart(MQtoHideQuickLinks)} ref={aboutClubRef}>
        <div css={styles.leftContent}>
          <div css={stylesClub.top}>
            <Text as="h3" size="5" css={stylesClub.title}>
              About this club
            </Text>
            {hasMoreInfo && (
              <>
                {accreditation && accreditation.isAccreditation && title && (
                  <div css={stylesClub.imageWrap}>
                    <img
                      src={publicPath(
                        `/images/common/ef-accredited-club-rating.svg`
                      )}
                      alt={`This club has an FA Accreditation`}
                      width="100%"
                    />
                    {accreditation && <AccredationLevel {...accreditation} />}
                  </div>
                )}
              </>
            )}
          </div>
          {county && (
            <DisplayInformation
              singleGroupValue={true}
              singleGroupLabelText="County FA"
              singleGroupValueText={county}
            />
          )}

          {filteredFootballTypesValues && (
            <DisplayInformation
              staticGroupLabel={true}
              staticGroupLabelText="Football Types"
              values={filteredFootballTypesValues}
            />
          )}

          {facilitiesValues && (
            <DisplayInformation
              dynamicGroupLabel={true}
              values={facilitiesValues}
            />
          )}
        </div>
      </div>
    </Fragment>
  );
};

ClubDetails.propTypes = {
  footballtypes: PropTypes.object,
  facilities: PropTypes.object,
  contact: PropTypes.object,
  contactAddress: PropTypes.string,
  county: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default ClubDetails;
